// extracted by mini-css-extract-plugin
module.exports = {"titleBlock":"titleBlock-module--titleBlock--2q_GK","title":"titleBlock-module--title--3OGKI","cat":"titleBlock-module--cat--2CZ8b"};